var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{ref:"check",attrs:{"size":_vm.size,"switch":"","disabled":_vm.disabled},on:{"input":_vm.handleChange},model:{value:(_vm.localChecked),callback:function ($$v) {_vm.localChecked=$$v},expression:"localChecked"}},[_c('span',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }